import { get } from '@/untils/axios.js'

// 用户统计
export const users_order_area    = params => get('/statistics/users-order-area', params)

// 用户统计
export const statistics_users = params => get('/statistics/users', params)

// 订单地区统计
export const statistics_order_area = params => get('/statistics/users-order-area', params)

// 销售商品列表
export const goods_sales_list = params => get('/statistics/goods-sales-list', params)

// 搜索排行列表
export const search_list = params => get('/search_list', params)

// 销售商品排行列表
export const goodsList = params => get('/statistics/goods', params)